import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Grid, InputAdornment } from "@mui/material";

import "./label-supp-details.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SupplierSelectComponent from "../../supplier-select-component/SupplierSelectComponent";
import LabelSupplierTable from "./label-supp-table";
import axios from "axios";
import {DateRangePicker} from '@mui/x-date-pickers-pro/DateRangePicker';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import { useOktaAuth } from "@okta/okta-react";

const LabelSupplierDetails = (props) => {
  const { handleKeyDown, usertype, supplierList, userId } = props;
  const [supplierNumber, setSupplierNumber] = useState(null);
  const [supplierTest, setSupplierTest] = useState([]);
  const [startSelectedDate, setStartSelectedDate] = useState(null);
  const [endDatedata, setEndDatedata] = useState(null);
  const { oktaAuth } = useOktaAuth();
  const [adminTabShow, setAdminTableShow] = useState(false);
  const [adminTabHide, setAdminTabHide] = useState(true);
  const [adminTabNoRecords, setAdminTabNoRecords] = useState(false);
  const [noTpData, setNoTpData] = useState("Specify a criteria first");

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const [value, setValue] = React.useState([new Date(), addDays(new Date(), 3)]);


  const supplierChangeHandler = (event) => {
    console.log(event);
    let temp = event.slice(0, 10);
    setSupplierNumber(temp);
  };

  function convert(str) {
    let date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handleStartSelect = (dates) => {
    setValue([dates[0] || "", dates[1] || ""]);
    const temp = convert(dates[0]);
    const temp1 = convert(dates[1]);
    setStartSelectedDate(temp);
    setEndDatedata(temp1);
  };

  useEffect(() => {
    if (supplierNumber) {
      supplierTestDetails();
    }
    if (startSelectedDate === null) {
      setStartSelectedDate("");
    }
    if (endDatedata === null) {
      setEndDatedata("");
    }
  }, [supplierNumber, startSelectedDate, endDatedata]);

  const supplierTestDetails = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/getSupplierTestDetails?userId=${supplierNumber}&start_date=${startSelectedDate}&end_date=${endDatedata}`,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      )
      .then((response) => {
        let temp = response;
        setSupplierTest(temp?.data);
        if (supplierTest.length > 0) {
          setAdminTableShow(true);
          setAdminTabHide(false);
          setSupplierTest(temp.data);
          setNoTpData("No Records");
          setAdminTabNoRecords(false);
        } else {
          setAdminTabHide(false);
          setAdminTableShow(false);
          setAdminTabNoRecords(true);
        }
      })
      .catch((error) => {
        setNoTpData(
          "An unexpected error ocurred while processing your request, please try again"
        );
        console.log(error);
      });
  };

  return (
    <>
      <Typography gutterBottom variant="h2" component="h2">
        Label Supplier Details
      </Typography>
      <Card className="cardcontainer ">
        <Grid container sx={{alignItems:"flex-start"}} spacing={2}>
          <Grid item size={{ xs:4, sm:4, md:4, lg:4, xl:4}}>
            <Typography
              variant="h3"
              fontWeight="semibold"
              component="p"
              gutterBottom
            >
              Supplier <span style={{ color: "red" }}>*</span>
            </Typography>
            <SupplierSelectComponent
              userType={usertype}
              supplierList={supplierList}
              supplierChangeHandler={supplierChangeHandler}
              handleKeyDown={handleKeyDown}
            />
          </Grid>
          <Grid item size={{ xs:4, sm:8, md:8, lg:8, xl:8}}>
            <div style={{ maxWidth: "50rem", overflow: "visible" }}>
              <Typography
                variant="h3"
                fontWeight="semibold"
                component="p"
                gutterBottom
              >
                Select Date
              </Typography>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateRangePicker
                  
                  onChange={handleStartSelect}
                  StartInputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                </LocalizationProvider>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container sx={{alignItems:"flex-start"}} spacing={4}>
          <Grid item size={{ xs:12}}>
            {adminTabHide && (
              <Box sx={{ paddingLeft: "32rem", paddingTop: "15rem" }}>
                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                  Specify a criteria first
                </Typography>
              </Box>
            )}

            {adminTabNoRecords && (
              <Box sx={{ paddingLeft: "32rem", paddingTop: "15rem" }}>
                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                  No records found
                </Typography>
              </Box>
            )}
            <br />
            <br />
            {adminTabShow && (
              <Box>
                <Card>
                  <LabelSupplierTable
                    supplierTest={supplierTest}
                    supplierNumber={supplierNumber}
                    noTpData={noTpData}
                  />
                </Card>
              </Box>
            )}
          </Grid>
        </Grid>
      </Card>

    </>
  );
};

export default LabelSupplierDetails;
